module.exports = __webpack_public_path__ + "img/Homer Simpson Happy-256.ab9a7757.png";